import { useEffect } from "react";
import { useState } from "react"

const useProuducts = () => {
    const [products, setProducts] = useState([]);
    useEffect(() => {
        fetch('./products.JSON')
            .then(res => res.json())
            .then(data => setProducts(data))

    }, [])
    //return necessary things
    return [products]
}

export default useProuducts;